oyc.FormFilter = {
  dependencies: ['FormStateTracking', 'Pager', 'Dropdown'],
  selectors: {
    container: '.form-container',
    filterContainer: '.jobs-filter-form',
    listContainer: '.form-list',
    fields: '[name^="tx_oycimport_list"]',
    submit: '.form-submit',
    reset: '.form-reset',
    countItems: '.item-count'
  },
  container: {},
  filterContainer: {},
  fields: {},
  fieldsMobile: {},
  countItems: {},
  listContainer: {},
  form: {},
  /**
   * @var {oyc.FormStateTracking}|null
   */
  fst: null,
  filterLastChanged: '',

  xhrSearch: {},
  xhrCount: {},

  ajaxQueryString: '?type=1202',
  debug: true,

  init: function () {
    this.container = $(this.selectors.container);
    if (0 < this.container.length) {
      let filterContainer = this.container.find(this.selectors.filterContainer);
      if (0 < filterContainer.length) {
        filterContainer.each(this.initContainer.bind(this));
        this.fst = oyc.FormStateTracking;
        this.addEvents();
      }
    }
  },
  initContainer: function (i, el) {
    let filterContainer = $(el);
    let container = filterContainer.closest(this.selectors.container);
    let form = (filterContainer.filter('form')[0] || filterContainer.find('form')[0] || filterContainer.closest('form')[0]);
    this.form[form.id] = form;
    this.filterContainer[form.id] = filterContainer;
    let selectorsFields = this.selectors.fields;
    if (form.dataset.fieldNamePrefix) {
      selectorsFields = this.selectors.fields.replace('tx_oycimport_list', form.dataset.fieldNamePrefix);
    }
    this.listContainer[form.id] = container.find(this.selectors.listContainer);
    this.fields[form.id] = filterContainer.find(selectorsFields);
    this.fieldsMobile[form.id] = this.fields[form.id].filter('[name*="-mobile"]');
    this.countItems[form.id] = container.find(this.selectors.countItems);
    if (form.dataset.formCacheFoundAndSet && this.formHasValues(form.id)) {
      this.invokeSubmit(form.id);
      // oyc.Pager.nextPage !== false && oyc.Pager.nextPage.abort();
      delete form.dataset.formCacheFoundAndSet;
    }
    this.updateDependentFilters(form.id);
  },
  addEvents: function () {
    this.container.on('click', this.selectors.submit, this.submitClick.bind(this));
    this.container.on('click', this.selectors.reset, this.resetClick.bind(this));
    for (let id in this.fields) {
      this.fields[id].on('change', this.fieldChange.bind(this));
      this.fields[id].closest('form').find('[name*="filter"]').on('blur', this.fieldChange.bind(this));
    }
  },
  formHasValues: function (formId) {
    let hasValue = false;
    this.fields[formId].each(function () {
      let val  = $(this).val();
      if (val.toString() !== '' || (Array.isArray(val) && 0 < val.length)) {
        hasValue = true;
      }
    });
    return hasValue;
  },
  submitClick: function (ev, formId) {
    if (typeof ev !== 'undefined') {
      ev.preventDefault();
      formId = ev.currentTarget.form.id;
    }
    /**
     * @todo maybe collect request in an object with formIds as properties as well
     * @type {*|jQuery|HTMLElement}
     */
    let formData = this.collectData(formId);
    formData.set('container-id', formId);

    if (this.xhrSearch[formId]) {
      this.xhrSearch[formId].abort();
    }
    if (this.xhrCount[formId]) {
      this.xhrCount[formId].abort();
    }
    oyc.FormCache.clear();
    oyc.FormCache.save();
    try {
      let xhr = this.invokeAjax(formData, oyc.static.FormFilter[this.form[formId].name].search);
      if (xhr) {
        xhr.formId = formId;
        xhr.done(this.listUpdate.bind(this))
        this.xhrSearch[formId] = xhr;
      }
    } catch (e) {
      console.error('request for search not executed', e);
    }
    if (!this.form[formId].dataset['noCount']) {
      try {
        let xhr = this.invokeAjax(formData, oyc.static.FormFilter[this.form[formId].name].count);
        if (xhr) {
          xhr.formId = formId;
          xhr.done(this.countUpdate.bind(this))
          this.container.find('.count-up-to').text(0);
          this.xhrCount[formId] = xhr;
        }
      } catch (e) {
        console.error('request for count not executed', e);
      }
    }
  },
  resetClick: function (ev) {
    let form = ev.currentTarget.form;
    form.reset();
    this.fst.deleteFormState(form);
    this.submitClick(undefined, form.id);
    ev.preventDefault();
  },
  collectData: function (id) {
    return new FormData(this.form[id]);
  },
  invokeSubmit: function (id) {
    if (this.filterContainer[id].hasClass('map-mode')) {
      return;
    }
    this.filterLastChanged && this.filterLastChanged === 'filter' && oyc.Dropdown.close();
    this.submitClick(undefined, id);
  },
  /**
   *
   * @param {FormData} formData
   * @param {int|undefined|null} typeNum
   */
  invokeAjax: function (formData, typeNum) {
    let url = this.ajaxQueryString
    if (typeNum === null) {
      return;
    }
    if (isFinite(typeNum)) {
      url = url.replace(/(type=)\d+/, '$1' + typeNum);
    }
    return $.post({
      processData: false,
      contentType: false,
      url: url,
      data: formData
    });
  },
  listUpdate: function (data, status, xhr) {
    let form = $(this.form[xhr.formId]),
      container = form.closest(this.selectors.container),
      itemList = container.find(this.selectors.listContainer);
    let result = $('<div>' + data + '</div>')
    if (result.find('.list-item').length === 0) {
      // no result found in response - toggle visibility and hide everything else
      container.find('.filter-no-result').replaceWith(result.find('.filter-no-result'));
      container.find('.filter-no-result').removeClass('hide');
      itemList.addClass('hide');
      container.find('.count-row:parent').addClass('hide');
    } else {
      // pagination is possible (load-more button exists)
      if (container.hasClass(this.Pager.selectors.container.substring(1))) {
        let pagerContainerId = container.attr('id');
        this.Pager.result[pagerContainerId] = $();
        this.Pager.fetchResponse(result, pagerContainerId);

        // empty list and remove messages if present
        let pageableList = container.find(this.selectors.listContainer);
        if (this.container.find('[name*="loadUpToPage"]').length) {
          // initial state is loaded with values from cache
          // otherwise a field with that name wouldn't be found
          let lastPageAppendedField = container.filter('#' + xhr.formId).find('[name*="loadUpToPage"]');
          container.data('currentPage', lastPageAppendedField.val());
          lastPageAppendedField.remove();
          this.Pager.appendItems(true, pagerContainerId);
        } else if (this.Pager.result[pagerContainerId].length > 0) {
          // a result for the current form is present
          container.data('clear-list', true);
          // replace list items
          if (pageableList.hasClass('hide')) {
            container.find('.filter-no-result, .pager-fallback').addClass('hide');
            pageableList.removeClass('hide');
            container.find('.count-row:parent').removeClass('hide');
          }
          // finally append the result
          this.Pager.appendItems(true, pagerContainerId);
          this.Pager.initContainer(0, container[0]);
        }
      } else {
        itemList.empty().append(result.find('.list-item'));
        oyc.Loader.hide('#content');
      }
    }

    this.xhrSearch[xhr.formId] = false;
  },
  countUpdate: function (data, status, xhr) {
    let counts = data;
    if (typeof data === 'string') {
      counts = JSON.parse(data);
    }
    console.log('oyc.FormFilter.countUpdate', counts);

    let vacancies = 0;
    if (typeof counts === 'object') {
      vacancies = counts.vacancies;
    } else if (typeof counts === 'number') {
      vacancies = counts;
    }
    if (this.countItems[xhr.formId]) {
      this.countItems[xhr.formId].text(this.countItems[xhr.formId].text().replace(/[0-9]+/, vacancies));
      this.countItems[xhr.formId].each((i, item) => {
        if (item.textContent.match("angebot")) {
          let e = '', s = 's';
          if (vacancies > 1) {
            e = 'e';
            s = '';
          }
          item.textContent = item.textContent.replace(/(aktuelle)s?/, '$1' + s).replace(/(angebot)e?/, '$1' + e);
        }
      })
    }
    this.xhrCount[xhr.formId] = false;
    this.countUpdateFilterItems(counts.all, xhr.formId);
  },
  countUpdateFilterItems: function (counts, formId) {
    for (let filterName in counts) {
      if (counts.hasOwnProperty(filterName)) {
        let filter = this.filterContainer[formId].find('.filter-' + filterName),
          filterItems = filter.find('.checkbox .filter-count');
        for (let i = 0; i < filterItems.length; i++) {
          let item = filterItems[i];
          let itemCount = 0;
          if (counts[filterName].hasOwnProperty(item.dataset.value)) {
            itemCount = counts[filterName][item.dataset.value];
            if (item.classList.contains('item')) {
              // if (item.classList.contains('active')) {
              $(item).closest('.dropdown')
                .find('[for="checkbox-' + filterName + '-' + item.dataset.value + '"] .filter-count')
                .text(itemCount);
              // }
            } else {
              item.closest('.checkbox').querySelector('input').disabled = false;
            }
            item.closest('.checkbox').classList.remove('disabled');
          } else if (item.dataset.value !== '' || counts.vacancies === 0) {
            if (item.classList.contains('item')) {
              item.classList.add('disabled');
            } else {
              item.closest('.checkbox').querySelector('input').disabled = true;
            }
            item.closest('.checkbox').classList.add('disabled');
          } else if (item.dataset.value === '') {
            itemCount = counts.all[filterName];
          }
          // finally updating the count
          if (item.classList.contains('item')) {
            item.querySelector('.filter-count').innerText = itemCount;
          } else {
            item.innerText = itemCount;
          }

          filter.find('.label[data-value="' + item.dataset.value + '"] .filter-count').text(itemCount);
        }
      }
    }
  },
  fieldChange: function (ev) {
    console.log('fieldChange', ev);
    let form = ev.target.closest('form');
    let value = ev.target.value;
    if (ev.target.type === 'checkbox' && ev.target.checked === false) {
      value = '';
      this.changeSubcategories(ev.currentTarget, ev.target.checked);
    }
    this.filterLastChanged = ev.target.name.replace(/.*\[([^\]]+)(-mobile)?].*/g, '$1');
    // track change in form state (unnecessary if values are reset after used)
    // @todo trigger event to listen to by fst
    if (this.fst.isTracked(form)) {
      this.fst.updateValue(this.filterLastChanged, value, form);
      this.fst.deleteProperty('lastPageAppended', form);
      this.fst.deleteProperty('scrollTop', form);
    }

    // if a value in a mobile field changed, change the value in the non-mobile field as well
    if (ev.currentTarget.name.match(/-mobile/)) {
      let desktopField = this.fields[form.id].filter('[name="' + ev.currentTarget.name.replace('-mobile', '') + '"][value="' + ev.currentTarget.value + '"]'),
        fieldType = desktopField.attr('type');
      if (fieldType === 'radio' || fieldType === 'checkbox') {
        desktopField.attr('checked', true);
      } else {
        desktopField.value(ev.currentTarget.value)
      }
    }
    this.updateDependentFilters(form.id);
    this.invokeSubmit(form.id);
  },
  updateDependentFilters: function (formId) {
    console.log('updateDependentFilters', formId);
    let filterContainer = this.filterContainer[formId];
    filterContainer.find('.field--depends-on:not([data-show-if=""])').each(function () {
      let showIf = $(this).data('show-if');
      if (!showIf) return;
      let [requiredField, requiredValue] = $(this).data('show-if').split(':');
      requiredValue = requiredValue.split(',');
      let selectedOptions = filterContainer.find('[name*="[' + requiredField + ']"] option:selected, [name*="[' + requiredField + ']"]:checked');
      let selectedValues = selectedOptions.map(function () {
        return $(this).val().trim();
      }).get();
      let hasMatch = selectedValues.some(function (text) {
        return requiredValue.indexOf(text) !== -1;
      });
      if (hasMatch) {
        $(this).removeClass('hide');
      } else {
        $(this).addClass('hide');
        $(this).find('select[name]').val('').trigger('change.nosubmit');
      }
    });
  },
  showLoader: function (formId) {
    const container = this.form[formId].closest(this.selectors.container);
    'Loader' in oyc && oyc.Loader.init(container.id) && oyc.Loader.show(container.id)
  },
  hideLoader: function (formId) {
    const container = this.form[formId].closest(this.selectors.container);
    'Loader' in oyc.Loader.hide(container.id);
  },
  changeSubcategories: function (checkbox, checked) {
    checkbox.parentNode.querySelectorAll('.child-checkboxes .checkbox').forEach(function (el) {
      el.checked = checked;
    });
  }
}
